import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';

import Constraint from 'js/components/Constraint';
import AppContent from '../AppContent';

const Code = animated(styled.div`
  font-weight: 700;
  font-size: 32px;
  color: #888;
`);

const Message = animated(styled.div`
  margin-top: 2rem;
  font-weight: 700;
  padding: 1rem 4rem;
`);

const Container = styled.div`
  margin: 5rem 0 2rem;
  text-align: center;
`;

const Img = styled.img`
  width: 90%;
  height: '450px
`;

export default ({ error }) => (
  <AppContent>
    <Constraint>
      <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {animation => (
          <Container>
            {error.status === 403 ? (
              <Img className="404_image" src="/images/v2/child-face-with-google-glasses-svgrepo-com.svg" />
            ) : error.status === 401 ? (
              <Img className="404_image" src="/images/v2/user-authentication-svgrepo-com.svg" />
            ) : (
              <Img className="404_image" src="/images/v2/development-and-progress-svgrepo-com.svg" />
            )}
            <Message style={animation}>{error.error}</Message>
            <div>
              <p>
                <img src="/images/icons/icon-left.svg" alt="go back" />
                <a href="/">back to home </a>
              </p>
            </div>
          </Container>
        )}
      </Spring>
    </Constraint>
  </AppContent>
);
